import RegulationPanelPanel from './RegulationPanel';

export { RegulationPanelPanel };

export default RegulationPanelPanel;
